<template lang="html">
    <div style="width:100%;background-color:#f3f3f3;height:100%; position: relative">
      <div class="logo-header">

         <v-slide-x-transition mode="out-in" class="hotsite-body" v-if="logoProviderConfirmation === ''">
          <div class="titulo-logo mb-4 float-l">
            <img v-show="!loading" src="../../assets/logo.png" alt=""> <h4 v-show="!loading">CondoPlaza</h4>
          </div>
        </v-slide-x-transition>

        <v-slide-x-transition mode="out-in" class="hotsite-body" v-else>
          <img :src="logoProviderConfirmation" :key="logoProviderConfirmation" alt="">
        </v-slide-x-transition>

        <v-progress-linear v-show="loading" v-bind:indeterminate="true" height="2" class="progrees-line" color="red" background-color="white"></v-progress-linear>
      </div>
      <v-container grid-list-md text-xs-center>
       <v-layout row wrap>
       <div class="box-email">      
            <div class="text-xs-center call-cupom">
            <strong>Entendemos a sua decisão.</strong>
            </div>    
            <div class="text-xs-center call-cupom texto">
            Muito obrigado!
            </div>  
         </div>
        </v-layout>
      </v-container>
     </v-flex>
    </div>
</template>

<script>
export default {
  data () {
    return {
      loading: true
    }
  },
  computed: {
    logoProviderConfirmation () {
      return this.$store.getters.logoProviderConfirmation
    }
  }
}
</script>

<style lang="css">
.box-email{
  background: #fff;
  width: 320px;
  margin: auto;
  padding: 20px;
  margin-top: 20px;
  border-radius: 20px;
}
.call-cupom {
  color: #464444;
  padding: 10px;
  font-size: 22px;
}
.cupom{
  border: 1px dashed gray;
  border-radius: 5px;
  margin: 20px;
}
.cupom input{
  font-size: 22px;
  width: 100%;
  text-align: center;
  padding: 0px 15px;
  color: #464444;
  text-transform: uppercase;
}
.texto{
	color: #42964d !important;
}
.logo-header{
    position: relative;
    width: 100%;
    text-align: center;
    padding: 20px;
    min-height: 145.63px;
    background-color: #fff;
}
.logo-header img, .administrator{
  max-width: 200px;
  max-height: 100px;
}
.titulo-logo{
  width: 300px;
  margin: auto;
}
.titulo-logo h4 {
  width: calc(100% - 80px);
  color: #a2a2a2;
  float: left;
  position: relative;
  top: 11px;
  font-size: 39px;
  left: 2px;
}
.titulo-logo img {
  width: 80px;
  height: 80px;
  float: left;
}
.progrees-line{
  position: absolute;
  bottom:0;
  margin: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// cancelarEnvio.vue?58a56dc9